export default __webpack_public_path__ + "static/media/element_spec_73.d3c31700.webp";